export enum Role {
	admin = 'admin', User = 'user', Judge = 'judge'
}